import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { AppStoreRedirectRoutesDeprecated } from "./AppStoreRedirectRoutesDeprecated";
import { AppStoreRedirectSiteDeprecated } from "./AppStoreRedirectSiteDeprecated";
import { AppStoreRedirectStoreDeprecated } from "./AppStoreRedirectStoreDeprecated";


//This FEATURE IS DEPRECATED AND WILL REMAIN IN THE CODE BASE AS BACKUP ACCORDING TO CUSTOMER REQUEST

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class AppStoreRedirectContainerDeprecated extends React.Component<IProps> {
    store: AppStoreRedirectStoreDeprecated;

    constructor(props: IProps) {
        super(props);
        this.store = new AppStoreRedirectStoreDeprecated();
    }

    async componentDidMount() {
        pushRoute(AppStoreRedirectRoutesDeprecated.ROOT);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("appStoreRedirect.document.title"),
            });
        } catch (error) {
            debug.log("### AppStoreRedirectContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("appStoreRedirect.document.title");
        return (
            <div>
                <Route exact path={AppStoreRedirectRoutesDeprecated.ROOT} component={this.withStore(AppStoreRedirectSiteDeprecated)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/appStoreRedirectDeprecated/AppStoreRedirectContainerDeprecated.tsx